export default __webpack_public_path__ + "static/media/LorenzoHanssens.b44e5c89.png";